module.exports = __webpack_public_path__ + "img/total1.097628c6.png";